<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .links {
    &.skeleton {
      @include mixins.skeleton(
        (
          background-color: colors.get(interfaceTransparentBlack_4),
          border-radius: 8px,
        )
      );
    }
  }
</style>

<script>
  import SocialButton from "@sourcewhale/shared/svelte-design-system/components/atoms/SocialButton.svelte";

  import { companyInsightsStore } from "./stores";
  import { LINK_KEYS, mapLinkToLogo } from "./utils";
</script>

{#each LINK_KEYS as key}
  {#if $companyInsightsStore?.[key]}
    <SocialButton
      icon={mapLinkToLogo($companyInsightsStore[key])}
      color="black_50"
      href={$companyInsightsStore[key]}
      alt="social-link"
      size="xxs"
    >
      <span slot="tooltip">{$companyInsightsStore[key]}</span>
    </SocialButton>
  {/if}
{/each}
